<template>
  <div class="register-code-container">
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h2>注册码管理</h2>
        <div class="header-buttons">
          <el-button type="info" @click="handleRefresh" icon="el-icon-refresh"></el-button>
        </div>
      </div>
      
      <div class="table-header">
        <div class="header-left">
          <el-button type="danger" @click="handleBatchDelete" :disabled="selectedCodes.length === 0">批量删除</el-button>
          <el-button type="primary" @click="handleGenerateDialog">批量生成</el-button>
        </div>
      </div>
      
      <el-table
        v-loading="loading"
        :data="codes"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="registerCode"
          label="注册码"
          width="150">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              :disabled="scope.row.used">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 生成注册码对话框 -->
    <el-dialog
      title="批量生成注册码"
      :visible.sync="generateDialogVisible"
      width="400px">
      <el-form :model="generateForm" :rules="generateRules" ref="generateForm" label-width="120px">
        <el-form-item label="生成数量" prop="count">
          <el-input-number
            v-model.number="generateForm.count"
            :min="1"
            :max="100"
            controls-position="right">
          </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="generateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleGenerate" :loading="generating">生成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'RegisterCodes',
  data() {
    return {
      loading: false,
      generating: false,
      codes: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      selectedCodes: [],
      generateDialogVisible: false,
      generateForm: {
        count: 10
      },
      generateRules: {
        count: [
          { required: true, message: '请输入生成数量', trigger: 'blur' },
          { type: 'number', min: 1, max: 100, message: '生成数量必须在1-100之间', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchCodes()
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return ''
      
      const date = new Date(dateString)
      
      // 格式化日期为 YYYY-MM-DD HH:mm:ss
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    fetchCodes() {
      this.loading = true
      const params = {
        page: this.currentPage,
        limit: this.pageSize
      }
      
      adminApi.getRegisterCodePage(params)
        .then(response => {
          if (response.data.code === 200) {
            this.codes = Array.isArray(response.data.data) ? response.data.data : []
            this.total = response.data.count || 0
          } else {
            this.codes = []
            this.total = 0
            this.$message.error(response.msg || '获取注册码列表失败')
          }
          this.loading = false
        })
        .catch(error => {
          console.error('获取注册码失败:', error)
          this.codes = []
          this.total = 0
          this.$message.error(error.msg || '获取注册码列表失败')
          this.loading = false
        })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchCodes()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchCodes()
    },
    handleSelectionChange(selection) {
      this.selectedCodes = selection
    },
    handleRefresh() {
      this.currentPage = 1
      this.fetchCodes()
    },
    handleGenerateDialog() {
      this.generateDialogVisible = true
      if (this.$refs.generateForm) {
        this.$refs.generateForm.resetFields()
      }
    },
    handleGenerate() {
      this.$refs.generateForm.validate(valid => {
        if (valid) {
          this.generating = true
          adminApi.generateRegisterCodes(this.generateForm.count)
            .then(response => {
              this.$message.success(`成功生成 ${this.generateForm.count} 个注册码`)
              this.generateDialogVisible = false
              this.fetchCodes()
              this.generating = false
            })
            .catch(error => {
              console.error('生成注册码失败:', error)
              this.$message.error('生成注册码失败: ' + (error.message || '未知错误'))
              this.generating = false
            })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该注册码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminApi.deleteRegisterCode(row.id)
          .then(response => {
            this.$message.success('删除成功')
            this.fetchCodes()
          })
          .catch(error => {
            console.error('删除注册码失败:', error)
            this.$message.error('删除注册码失败: ' + (error.message || '未知错误'))
          })
      }).catch(() => {
        // 用户取消删除操作
      })
    },
    handleBatchDelete() {
      if (this.selectedCodes.length === 0) {
        this.$message.warning('请选择要删除的注册码')
        return
      }
      
      this.$confirm(`确认删除选中的 ${this.selectedCodes.length} 个注册码吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const ids = this.selectedCodes.map(item => item.id)
        adminApi.batchDeleteRegisterCodes(ids)
          .then(response => {
            this.$message.success('批量删除成功')
            this.fetchCodes()
          })
          .catch(error => {
            console.error('批量删除注册码失败:', error)
            this.$message.error('批量删除注册码失败: ' + (error.message || '未知错误'))
          })
      }).catch(() => {
        // 用户取消删除操作
      })
    }
  }
}
</script>

<style scoped>
.register-code-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.header-buttons {
  display: flex;
  align-items: center;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-input-number {
  width: 180px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.header-left, .header-right {
  display: flex;
  align-items: center;
}
</style> 